module.exports = __webpack_public_path__ + "img/002-heart.ce709d6c.png";